
import XhStructure from './XhStructure';
import arrayMixin from './arrayMixin';

export default {
  name: 'XhStructureCell', // 新建 structure-cell
  components: {
    XhStructure: XhStructure
  },
  mixins: [arrayMixin],
  props: {
    placeholder: {
      type: String,
      default: '选择部门'
    },
    radio: {
      // 是否单选
      type: Boolean,
      default: true
    },
    max: {
      type: Number,
      default: 2
    }
  },
  data: function data() {
    return {
      showPopover: false // 展示popover
    };
  },

  computed: {
    showDataValue: function showDataValue() {
      if (this.dataValue && this.dataValue.length > this.max) {
        return this.dataValue.slice(0, this.max);
      }
      return this.dataValue;
    }
  },
  watch: {},
  mounted: function mounted() {},

  methods: {
    /** 选中 */
    checkStructure: function checkStructure(data) {
      if (this.radio && data && data.length) {
        this.showPopover = false;
      }
      this.dataValue = data;
      this.$emit('value-change', {
        item: this.item,
        index: this.index,
        value: data
      });
    },

    /** 删除 */
    deletestru: function deletestru(item, index) {
      this.dataValue.splice(index, 1);
      this.$emit('value-change', {
        item: this.item,
        index: this.index,
        value: this.dataValue
      });
    },

    /** 聚焦动作 */
    focusClick: function focusClick() {
      this.$emit('focus');
    }
  }
};